import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import CONSTANTS from "shared/constants";

export const initialState = {
  deviceId: null,
  user: {
    rfcs: {},
  },
  activeRfc: null,
  rfcRecentCfdis: {},
  system: {
    isLoggingOut: false,
  },
};

export const useStore = create(
  persist(
    (set, get) => ({
      ...initialState,

      clearStore: () => set(initialState),

      setDeviceId: (deviceId) =>
        set((state) => ({ ...state, deviceId: deviceId })),

      setUser: (user) => set((state) => ({ ...state, user: user })),

      setActiveRfc: (activeRfc) =>
        set((state) => {
          if (activeRfc === "onboarding") {
            return { ...state, activeRfc: activeRfc };
          } else if (activeRfc === "admin-empty") {
            return { ...state, activeRfc: activeRfc };
          }

          let rfcs = Object.keys(state.user.rfcs);

          if (rfcs.length <= 0) {
            return state;
          }

          if (!!!activeRfc) {
            rfcs.sort();
            activeRfc = state.user.rfcs[rfcs[0]]["rfc"];
          }
          return { ...state, activeRfc: activeRfc };
        }),

      setCfdiSearchFilters: (cfdiSearchFilters) =>
        set((state) => ({ ...state, cfdiSearchFilters: cfdiSearchFilters })),

      updateUserRfc: (userRfc) =>
        set((state) => {
          return {
            ...state,
            user: {
              ...state.user,
              rfcs: {
                ...state.user.rfcs,
                [userRfc.rfc]: userRfc,
              },
            },
          };
        }),

      setRfcRecentCfdis: (rfc, type, cfdis) =>
        set((state) => {
          if (state.rfcRecentCfdis.hasOwnProperty(rfc)) {
            state.rfcRecentCfdis[rfc][type] = cfdis.slice(0, 20);
          } else {
            state.rfcRecentCfdis[rfc] = {
              [type]: cfdis.slice(0, 20),
            };
          }

          return state;
        }),

      setStartLogout: () =>
        set((state) => {
          return {
            ...state,
            system: {
              ...state.system,
              ["isLoggingOut"]: true,
            },
          };
        }),

      setEndLogout: () =>
        set((state) => {
          return {
            ...state,
            system: {
              ...state.system,
              ["isLoggingOut"]: false,
            },
          };
        }),

      setSystemFlag: (key, value) =>
        set((state) => {
          return {
            ...state,
            system: {
              ...state.system,
              [key]: value,
            },
          };
        }),
    }),
    {
      name: CONSTANTS.PROD ? "PROD_STORE" : "DEV_STORE",
      storage: createJSONStorage(() => localStorage),
    }
  )
);
